import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <h2>Why Get a Custom Software for Your Business Needs?</h2>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                       <p>With revenue expected to surpass US$698.80bn in 2024, there is no doubt that custom software development is going to grow further, offering a strategic choice for businesses looking to improve their operations and productivity.</p>
                       <p>Here is a closer look at the appealing reasons why you should choose custom software development to get a competitive edge over your competition:</p>
                    </Col>
                </Row>
                <Row className="h-100 buss-padd">
                <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                    <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Customized Solutions</h6>
                            <p>Custom software development lets businesses craft solutions accurately customized to their detailed requirements, securing optimal functionality and performance.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Scalability and Flexibility</h6>
                            <p>Custom solutions improve alongside your business, adapting to changing needs, and ensuring long-term flexibility and scalability compared to off-the-shelf software.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Improved Security Measures</h6>
                            <p>Custom software grants security control, allowing for the implementation of customized, robust measures aligned with your business needs, effectively safeguarding sensitive data.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Flawless Integration</h6>
                            <p>Custom software effortlessly integrates with your current systems and procedures, reforms operations, and endorses a consistent digital environment.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Improved User Experience</h6>
                            <p>Custom software prioritizes user-centric design, ensuring a flawless and intuitive experience, and enhancing user satisfaction.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Constant Support and Updates</h6>
                            <p>Custom software development offers continuous support and updates, ensuring optimal system performance and alignment with the latest technological advancement.</p>
                        </div>
                    </div>
                </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Androidbuss